<template>
  <ipo3-page>
    <template slot="title">{{title}}</template>
    <template slot="tools">
      <el-button type="primary" @click="goBack" icon="el-icon-back">{{$t('btns.back')}}</el-button>
    </template>
    <template slot="page">
      <div id="home-edit">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item label="商店名稱（繁）" prop="content">
            <el-input v-model="ruleForm.shop_name_tw"></el-input>
          </el-form-item>
          <el-form-item label="商店名稱（簡）" prop="content">
            <el-input v-model="ruleForm.shop_name_cn"></el-input>
          </el-form-item>
          <el-form-item label="商店名稱（EN）" prop="content">
            <el-input v-model="ruleForm.shop_name_en"></el-input>
          </el-form-item>
          <el-form-item label="商店圖標" prop="content">
            <el-input v-model="ruleForm.shop_icon"></el-input>
          </el-form-item>
          <el-form-item label="物語商店_url" prop="content">
            <el-input v-model="ruleForm.shop_url"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </ipo3-page>
</template>
<script>
export default {
  name: "setting-edit",
  data() {
    return {
      title: '一般設置',
      ruleForm: {
        shop_name_tw: '',
        shop_name_cn: '',
        shop_name_en: '',
        shop_url: '',
        shop_icon: '',
      }
    };
  },

  created() {
      this.getData();
  },

  methods: {
    getData() {
      var self = this;
      this.$http.get("/admin/setting", {}).then(res => {
        self.ruleForm = res.data;
      });
    },
    onSubmit() {
      let params = Object.assign({},this.ruleForm);
      this.$http.post("/admin/setting/save", params).then(res => {
        this.$message.success("保存成功");
      });
    },
  }
};
</script>

<style lang="less">
#home-edit {
  width: 800px;
  text-align: left;
}
</style>